export default __webpack_public_path__ + "static/media/icaew_background_m1.94ce4dbf.jpg";